<template>
    <div class="p-8 max-w-md mx-auto text-center">
      <h1 class="text-3xl font-bold mb-4">Access Denied</h1>
      <p class="mb-4">You do not have permission to view this page.</p>
      <router-link to="/" class="text-blue-500 underline">
        Return to Login
      </router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NoPermission',
  };
  </script>
  